import { TableResponse } from "..";

export enum PriceMasterStatus {
  active = "active",
  inactive = "inactive",
}

export enum ItemType {
  FacilitySlot = "facility_slot",
  Membership = "membership",
  Product = "product",
  // Event = "event",
  CreditAddOns = "credit_add_ons"
}

export interface PriceMaster {
  id?: number;
  org_id: number;
  rule_name: string;
  rule_code: string;
  item_type: ItemType;
  status: PriceMasterStatus;

  // Pricing Fields
  price?: number;
  reg_fee?: number; // Only for Membership
  enable_plan_pricing: boolean;
  plan_pricing?: Array<{
    group_id: number;
    membership_plan_ids: number[];
    price: number;
  }>;
  enable_group_pricing: boolean;
  group_pricing?: Array<{
    group_id: number;
    price: number;
  }>;
  enable_special_pricing: boolean;
  special_pricing?: Array<{
    name: string;
    price: number;
    date_from?: string;
    date_to?: string;
  }>;
}

export type PriceMasterTable = TableResponse<PriceMaster>;
